import React from 'react';

const DashboardIcon = (props) => (
  <svg data-type="fill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <path
      d="M8 4C5.812 4 4 5.813 4 8v14c0 2.188 1.813 4 4 4h10c2.188 0 4-1.813 4-4V8c0-2.188-1.813-4-4-4Zm22 0c-2.188 0-4 1.813-4 4v6c0 2.188 1.813 4 4 4h10c2.188 0 4-1.813 4-4V8c0-2.188-1.813-4-4-4ZM8 8h10v14H8Zm22 0h10v6H30Zm0 14c-2.188 0-4 1.813-4 4v14c0 2.188 1.813 4 4 4h10c2.188 0 4-1.813 4-4V26c0-2.188-1.813-4-4-4Zm0 4h10v14H30ZM8 30c-2.188 0-4 1.813-4 4v6c0 2.188 1.813 4 4 4h10c2.188 0 4-1.813 4-4v-6c0-2.188-1.813-4-4-4Zm0 4h10v6H8Zm0 0"
    />
  </svg>
);

export default DashboardIcon;
